<bb-page-header [icon]="'gavel'" [title]="'AUCTIONS' | translate" [filterConfig]="filterConfig"
	[currentPath]="listConfiguration.activePath">
</bb-page-header>

<div class="body-column">
	<span class="message info" [innerHtml]="'INFO.GLOBAL_PREBID_SETTINGS' | translate"></span>
	<div class="options">
		<div class="action-buttons">
			<a class="button" [routerLink]="['/adservices/auction', 'new']"><i class="fa fa-plus"></i>
				<span class="short-label">{{ 'CREATE_NEW' | translate }}</span>
				<span class="long-label">{{ 'CREATE_NEW_AUCTION' | translate }}</span>
			</a>
			<bb-button icon="cog" (click)="openGlobalSettings()">
				{{ 'GLOBAL_PREBID_SETTINGS' | translate }}
			</bb-button>
		</div>
	</div>

	<bb-table-container>
		<bb-table-header>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="name">{{ 'NAME' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="code">{{ 'CODE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell optional property="createddate">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updateddate">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row" (dblclick)="redirectToDetails(row.id)">
			<bb-table-cell property="id">{{ row.id }}</bb-table-cell>
			<bb-table-cell property="name" class="overflow">{{ row.data.name }}</bb-table-cell>
			<bb-table-cell property="code" class="overflow">{{ row.data.code }}</bb-table-cell>
			<bb-table-cell property="status">
				<span [innerHTML]="row.data | statusIcon"></span>
			</bb-table-cell>
			<bb-table-cell optional property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">
				{{ row.data.createddate | bbDate:'relative' }}
			</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}
			</bb-table-cell>
			<bb-table-cell optional property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">
				{{ row.data.updateddate | bbDate:'relative' }}
			</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">
				{{ row.data.updatedBy }}
			</bb-table-cell>
			<bb-table-cell class="row-actions buttons" (click)="$event.stopPropagation()">
				<!-- stopPropagation so the row doesn't get selected -->
					<a [routerLink]="['/adservices/auction', row.data.id]">
						<bb-button>
							<i class="fa fa-edit"></i>
						</bb-button>
					</a>

					<a [ngClass]="{disabled: !putRight}" (click)="deleteSingle(row.data)">
						<bb-button>
							<i class="fa fa-trash-can"></i>
						</bb-button>
					</a>
			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="!rows?.length">{{ 'NO_AUCTIONS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>
</div>
